import { Component } from '@angular/core';
import { HeaderComponent } from '../plantilla/header/header.component';
import { FooterComponent } from '../plantilla/footer/footer.component';
import { HeroComponent } from '../hero/hero.component';
import { ActionCallComponent } from '../action-call/action-call.component';
import { FeaturedInsuranceComponent } from '../dive-insurance/featured-insurance/featured-insurance.component';
import { MainGalleryComponent } from '../gallery/main-gallery/main-gallery.component';
import { CoverageSummaryComponent } from '../coverage-summary/coverage-summary.component';

@Component({
  selector: 'app-inicio',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    HeroComponent,
    ActionCallComponent,
    FeaturedInsuranceComponent,
    MainGalleryComponent,
    CoverageSummaryComponent,
  ],
  templateUrl: './inicio.component.html',
  styleUrl: './inicio.component.scss',
})
export class InicioComponent {}
